import styled from "styled-components";

export const Image = styled.img`
  width: 100%;
  margin-bottom: 1.2rem;

  ${({ theme }) => theme.media.md`
    margin-bottom: 0.4rem;
  `}
`;

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -1.7rem;

  ${({ theme }) => theme.media.md`
    margin: -1.2rem;
  `}
`;

export const Cell = styled.div`
  width: calc(100% / 3);
  padding: 1.7rem;

  ${({ theme }) => theme.media.md`
    padding: 1.2rem;
  `}

  ${({ theme }) => theme.media.sm`
    width: 100%;
  `}
`;

export const HowItWorks = styled.div`
  margin-top: 4.8rem;
`;

export const CellHeader = styled.div`
  margin-bottom: 0.4rem;

  p {
    color: #181c24;
  }
`;
